export default __webpack_public_path__ + "static/media/bh-ico.45ae5796.svg";